// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgDoorLock = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.75 2a.75.75 0 0 0-.75.75v14.5c0 .414.336.75.75.75h4.5a.75.75 0 1 0 0-1.5H3.5v-13h8v1.75a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-.75-.75h-9.5Zm10 8a1.25 1.25 0 1 1 2.5 0v1h-2.5v-1Zm-1.5 1v-1a2.75 2.75 0 1 1 5.5 0v1h.5a.75.75 0 0 1 .75.75v4.5A1.75 1.75 0 0 1 16.25 18h-4.5A1.75 1.75 0 0 1 10 16.25v-4.5a.75.75 0 0 1 .75-.75h.5Zm.25 5.25V12.5h5v3.75a.25.25 0 0 1-.25.25h-4.5a.25.25 0 0 1-.25-.25Zm-5.5-7a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-1.5 0V10A.75.75 0 0 1 6 9.25Z"
    />
  </svg>
)

export default SvgDoorLock
